module.exports = __webpack_public_path__ + "media/images/middle-image-d663b9c180abf27ab3d64712e96df51a.png";